import { useContext } from 'react';
import { AppContext } from '@ctsu/loader';
import moment from 'moment';
import 'moment-timezone';
import { useLocation } from 'react-router';

export const getUIDateFormat = inputDt => (inputDt ? new Date(moment(inputDt, 'DD-MMM-YYYY')) : '');

export const getApiDateFormat = inputDt => (inputDt ? moment(inputDt).format('DD-MMM-YYYY') : '');

export const getUIDTFormat = inputDt => (inputDt ? new Date(moment(inputDt, 'DD-MMM-YYYY hh:mm A z')) : '');

export const getUIDTNZFormat = inputDt => (inputDt ? new Date(moment(inputDt, 'DD-MMM-YYYY hh:mm A')) : '');

export const getApiDTFormat = inputDt => (inputDt
  ? moment(inputDt)
    .tz('America/New_York')
    .format('DD-MMM-YYYY hh:mm A z')
  : '');

export const getApiDTNZFormat = inputDt => (inputDt
  ? moment(inputDt)
    .tz('America/New_York')
    .format('DD-MMM-YYYY hh:mm A')
  : '');

export function useCtxParseValue(key) {
  const context = useContext(AppContext);
  return key && context && context.application
    && context.application.appConfig[key]
    && JSON.parse(context.application.appConfig[key]);
}

export function useCtxValue(key) {
  const context = useContext(AppContext);
  return context && context.application && context.application.appConfig[key];
}

export function GetFromCtxValue(context, key) {
  return context && context.application && context.application.appConfig[key];
}

export function GetUserFullName() {
  const context = useContext(AppContext);
  return context && context.session && context.session.userFirstLast;
}

export const getSessionByKey = key => (key ? sessionStorage.getItem(key) : '');
export const
  setSessionForKey = (key, value) => (key && value && sessionStorage.setItem(key, value));

export function getEmptyValue(value) {
  return (value || '');
}

export function getTableColumns(cols) {
  return cols.map((col, i) => ({
    name: col[0],
    type: col[1],
    label: col[2],
    align: col[3],
    filterable: col[4],
    visible: col[5]
  }));
}

export function OpenLink(link) {
  const win = window.open(link, '_blank');
  win.focus();
}

export const getDecodedQueryParams = (queryParam) => {
  // console.log(query);
  // const q = query.get('q');
  // const params = atob(queryParam);
  return atob(queryParam);
};

export const useGetPathProtocol = () => {
  const location = useLocation();
  const params = getDecodedQueryParams(location.pathname.split('/').pop());
  return params.split('/').shift();
}

export const getEncodedQueryParams = (urlPath, params) => {
  const encodedData = btoa(params);
  return `${urlPath}${encodedData}`;
};

export const getGAId = () => {
  const GACode = type => {
    try {
      return JSON.parse(process.env.REACT_APP_GA)[type];
    } catch (e) {
      return '';
    }
  };
  const websiteEnv = window.location.hostname;
  let gaTrackingId = '';
  if (websiteEnv.search('unit-') >= 0) {
    gaTrackingId = GACode('UNIT');
  } else if (websiteEnv.search('uat-') >= 0) {
    gaTrackingId = GACode('UAT');
  } else if (websiteEnv.search('ci-') >= 0 || websiteEnv.search('localhost') >= 0) {
    gaTrackingId = GACode('CI');
  } else if (websiteEnv.search('test-') >= 0) {
    gaTrackingId = GACode('TEST');
  } else {
    gaTrackingId = GACode('PROD');
  }
  return gaTrackingId;
};

export const getSysDate = () => {
  const today = new Date();
    const dd = String(today.getDate()).padStart(2, '0');
    const MMM = today.toLocaleString('en-US', { month: 'short' });
    const yyyy = today.getFullYear();
    return `${dd}-${MMM}-${yyyy}`;
}
